import React from 'react';
import { ComplementaryServiceTypeState } from '../../../types/zitoneoServicesTypes';
import Icon from '../../../../../muiComponents/Icon';
import Tag from '../../../../../muiComponents/Tag';
import useTranslate from '../../../../../customHooks/useTranslate';

interface ZitoneoAvailableServiceProps {
    service: ComplementaryServiceTypeState;
    onClick: () => void;
}

const ZitoneoAvailableService = ({
    service,
    onClick,
}: ZitoneoAvailableServiceProps) => {
    const translate = useTranslate();

    return (
        <button
            className='zitoneo-service__available-item width100perc'
            onClick={onClick}
        >
            <div className='service_available__title'>
                <div className='service_available__icon'>
                    <Icon iconName='Add' />
                </div>
                {service.Name}
                {service.IsNewService && (
                    <Tag
                        variant='outlined'
                        color='cyan'
                        text={translate('new')}
                    />
                )}
            </div>
        </button>
    );
};

export default ZitoneoAvailableService;
